import { Type, Transform } from 'class-transformer'
import { DateTime } from 'luxon'
import { SkillAssessment } from 'types/types'

export default class WorkReference {
  id!: number
  nurse_id!: number
  nurse_name!: string
  nurse_gdc_number!: string
  reference_name!: string
  patient_communication!: SkillAssessment
  scaling_and_polishing!: SkillAssessment
  infection_control_procedures!: SkillAssessment
  record_keeping_and_documentation!: SkillAssessment
  time_management!: SkillAssessment
  teamwork_and_collaboration!: SkillAssessment
  professionalism!: SkillAssessment
  comments!: string
  
  @Type(() => DateTime)
  @Transform(({ value }) => DateTime.fromISO(value))
  created_at!: DateTime
}
